import { Fields } from 'common/form';
import { Variable } from 'common/ui';
import {
  Channels,
  CustomTemplatedMessageVariables
} from 'generated-graphql/types';
import {
  SourcingSharedCustomizeMessageEmailFormData,
  SourcingSharedCustomizeMessageSmsFormData
} from 'modules/sourcing-shared/forms';
import { SOURCING_EXTERNAL_DEFAULT_SUBJECT_LINE } from 'modules/sourcing-external/constants/sourcingExternalDefaultSubjectLine';
import { SMS_MAX_CHARS_CUSTOMIZE } from 'modules/sourcing-shared/constants';

const OPENING_MESSAGE_SUB_LABEL_SMS = `▪ ${SMS_MAX_CHARS_CUSTOMIZE} character maximum.
    ▪ An opt-out message with "STOP" must be included.
    ▪ To personalise for each recipient: type @ or { and choose a variable.`;

const OPENING_MESSAGE_SUB_LABEL_EMAIL = `▪ Emails are sent as plain text.
    ▪ To personalise for each recipient: type @ or { and choose a variable.
    ▪ An opt out message is automatically added at the end of your email.`;

type GetSourcingSharedCustomizeMessageFieldsProps = {
  availableVariables: Variable[];
  defaultCustomTemplatedMessage: string;
  channelType: Channels;
};

export const getSourcingSharedCustomizeMessageFields = ({
  availableVariables,
  defaultCustomTemplatedMessage,
  channelType
}: GetSourcingSharedCustomizeMessageFieldsProps):
  | Fields<SourcingSharedCustomizeMessageEmailFormData>
  | Fields<SourcingSharedCustomizeMessageSmsFormData> => {
  return {
    agent: {
      type: 'agentInput',
      label: 'Agent name',
      subLabel: 'Use your own name or a pseudonym.'
    },
    customTemplatedSubjectLine: {
      type: 'templated-text',
      label: 'Subject line',
      subLabel:
        'To personalise for each recipient: type @ or { and choose a variable.',
      availableVariables: availableVariables.filter(
        (variable) =>
          variable.value !== CustomTemplatedMessageVariables.CandidateRelevance
      ),
      defaultValue: SOURCING_EXTERNAL_DEFAULT_SUBJECT_LINE,
      minHeight: 66,
      // Hide subject line field for SMS channel
      hidden: channelType !== Channels.Email
    },
    customTemplatedMessage: {
      type: 'templated-text',
      label: 'Opening message',
      subLabel:
        channelType === Channels.Sms
          ? OPENING_MESSAGE_SUB_LABEL_SMS
          : OPENING_MESSAGE_SUB_LABEL_EMAIL,
      availableVariables,
      minHeight: 300,
      defaultValue: defaultCustomTemplatedMessage,
      charactersCountLimit:
        channelType === Channels.Sms ? SMS_MAX_CHARS_CUSTOMIZE : undefined
    }
  };
};
